import { NumberInput, SelectInput, TextInput, required } from 'react-admin';
import { ReactElement } from 'react';
import { RowFormConfigurable } from '@react-admin/ra-editable-datagrid';
import { labelInputTypeChoices } from '../../Labels/inputTypes';

interface LabelRowFormProps {
  categoryId: string;
}

export default function LabelRowForm({ categoryId }: LabelRowFormProps): ReactElement {
  return (
    <RowFormConfigurable
      defaultValues={{
        type: 'labels',
        relationships: {
          category: {
            data: {
              id: categoryId,
              type: 'categories',
            },
          },
        },
      }}
    >
      <TextInput label="Name" source="attributes.name" validate={[required()]} />
      <SelectInput
        label="Input Type"
        source="attributes.input_type"
        choices={labelInputTypeChoices}
        validate={[required()]}
      />
      <NumberInput
        label="Display Order"
        source="attributes.display_order"
        validate={[required()]}
      />
      <TextInput label="Unit" source="attributes.unit" />
      <TextInput label="Direction" source="attributes.direction" />
    </RowFormConfigurable>
  );
}
